module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av139-3b63ab45b2351d944096feaf391cfb81.jpg";